import {OperationalHierarchyColumn} from "./OperationalHierarchyColumn";
import {ManagedTab} from "../../../managed-tabs";
import {TabBody} from "../../../tab-content";

export const OperationalHierarchyTab: ManagedTab = () => {
  return (
    <TabBody name={"hierarchy-tab"}>
      <OperationalHierarchyColumn />
    </TabBody>
  );
};
